/**
 * @ngdoc object
 * @name ExternalApplicationsResource
 * @requires $resource
 */

'use strict';

angular.module('pulse')
  .factory('ExternalApplicationsResource',
    ['$resource',
      function ($resource) {
        return $resource(
          config.baseURL + '/external/:ext/:id',
          {ext: '@ext', id: '@id'},
          {
            getTypes: {method: 'GET', params: {ext:'types'}, isArray:true},
            getType: {method: 'GET', params: {ext:'types'}},
            getConfigs: {method: 'GET', params: {ext:'configs'}, isArray:true},
            getConfig: {method: 'GET', params: {ext:'configs'}},
            createConfig: {method: 'POST', params: {ext:'configs'}},
            updateConfig: {method: 'POST', params: {ext:'configs'}},
            deleteConfig: {method: 'DELETE', params: {ext:'configs'}}
          }
        );
      }
    ]
  );
